import React from "react";
import { faDizzy, faFaceGrinStars, faGrinSquintTears, faHeart } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { UserPill } from "@/components";
import { Animation, CoreUser, Reaction, ReactionType } from "@/gql/generated/graphql";

const iconMap = {
  [ReactionType.Love]: faHeart,
  [ReactionType.Laugh]: faGrinSquintTears,
  [ReactionType.Stars]: faFaceGrinStars,
  [ReactionType.Dizzy]: faDizzy
}

type MinimalReaction = {
  type: ReactionType,
  user: Pick<CoreUser, "avatarUrl" | "name" | "id">
}

export const ReactionsBreakdown = ({ reactions }: { reactions: MinimalReaction[] }) => {
  if (reactions.length === 0) return null;

  const flattenedReactions = reactions.reduce((flattened, { type, user }) => {
    if (!flattened[user.name]) {
      flattened[user.name] = { types: [], user };
    }

    // dedupe reactions to hide abuse
    if (!flattened[user.name].types.includes(type)) {
      flattened[user.name].types.push(type);
    }

    return flattened;
  }, {} as Record<string, { types: ReactionType[], user: MinimalReaction['user'] }>);

  return (
    <ol className="flex -mx-1 flex-wrap">
      {Object.keys(flattenedReactions).map((username) => {
        const reaction = flattenedReactions[username];
        const icons = reaction.types.map((type) => (<FontAwesomeIcon key={type} icon={iconMap[type]} className="mr-1 last:mr-0" size="xs" />))

        return (
          <li
            key={username}
          >
            <UserPill user={reaction.user} suffix={<span className="ml-1 p-0.5">{icons}</span>} />
          </li>
        );
      })}
    </ol>
  );
};
